import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=253ea3b0&scoped=true&"
import script from "./Ticket.vue?vue&type=script&lang=js&"
export * from "./Ticket.vue?vue&type=script&lang=js&"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=253ea3b0&prod&lang=scss&"
import style1 from "./Ticket.vue?vue&type=style&index=1&id=253ea3b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ea3b0",
  null
  
)

export default component.exports